<template>
<div class="champion-wrap">
    <h2 class="champion-label">ロードレース全日本チャンピオン</h2>
    <div class="champion-container">
        <button class="history__head center " @click="toggle('60')"><span class="history__head--circle">1965-1970</span></button>
        <div class="champions">
          <section class="champions__sec">
            <h2 class="year-title">1965年<span class="year-title__sub">昭和40年</span></h2>
            <ul>
                <li>鈴木忠雄／50cc</li>
                <li>神谷忠／90cc</li>
                <li>宇野順一郎／125cc</li>
                <li>高武富久美／250cc</li>
                <li>隅谷守男／350cc</li>
            </ul>
          </section>
          <section class="champions__sec">
            <h2 class="year-title">1966年<span class="year-title__sub">昭和41年</span></h2>
            <ul>
                <li>滋野靖穂／50cc</li>	
                <li>滋野靖穂／90cc</li>
                <li>P.リード／350cc</li>
            </ul>
          </section>
          <section class="champions__sec">
            <h2 class="year-title">1967年<span class="year-title__sub">昭和42年</span></h2>
            <ul>
                <li>柴正之／ジュニア50cc</li>
                <li>田中隆造／ジュニア90cc</li>
                <li>大沢安男／ジュニア125cc</li>
                <li>太田耕治／ジュニア250cc</li>
                <li>宮沢善次／ジュニア251cc以上</li>
                <li>伊藤光夫／セニア50cc</li>
                <li>滋野靖穂／セニア90cc</li>
                <li>増田恒弘／セニア125cc</li>
                <li>矢野啓司／セニア250cc</li>
                <li>松永喬／セニア251cc以上</li>
            </ul>
          </section>
          <section class="champions__sec">
            <h2 class="year-title">1968年<span class="year-title__sub">昭和43年</span></h2>
            <ul>
                <li>角谷新二／アマチュア90cc</li>
                <li>鈴木聖弘／アマチュア125cc</li>
                <li>大脇俊夫／ アマチュア250cc</li>
                <li>中山仁／アマチュア251cc以上</li>
                <li>酒井奎吾／ジュニア90cc</li>
                <li>森井一夫／ジュニア125cc</li>
                <li>谷口茂夫／ジュニア250cc</li>
                <li>菱木哲哉／ ジュニア251cc以上</li>
                <li>神谷良明／セニア90cc</li>
                <li>馬場忠雄／セニア125cc</li>
                <li>和田正宏／セニア250cc</li>
                <li>松永喬／ セニア251cc以上</li>
            </ul>
          </section>
          <section class="champions__sec">
            <h2 class="year-title">1969年<span class="year-title__sub">昭和44年</span></h2>
            <ul>
                <li>野田正彦／アマチュア90cc</li>
                <li>斉藤茂憲／アマチュア125cc</li>
                <li>中尾康夫／ アマチュア250cc</li>
                <li>数井隆／アマチュア251cc以上</li>
                <li>角谷新二／ジュニア90cc</li>
                <li>高井幾次郎／ジュニア125cc</li>
                <li>尾崎俊彦／ジュニア250cc</li>
                <li>里村祥二／ジュニア251cc以上</li>
                <li>小田豊／セニア90cc</li>
                <li>隅谷守男／セニア125cc</li>
                <li>金谷秀夫／セニア250cc</li>
                <li>隅谷守男／ セニア251cc以上</li>
            </ul>
          </section>
          <section class="champions__sec">
            <h2 class="year-title">1970年<span class="year-title__sub">昭和45年</span></h2>
            <ul>
                <li>岩道博／ノービス90cc</li>
                <li>柴谷正昭／ノービス125cc</li>
                <li>小塚法柾／ノービス250cc</li>
                <li>鍋田正明／ ノービス251cc以上</li>
                <li>江崎正／ジュニア90cc</li>
                <li>青山英二／ジュニア125cc</li>
                <li>糟野雅治／ジュニア250cc</li>
                <li>只野光男／ ジュニア251cc以上</li>
                <li>近藤英二／セニア90cc</li>
            </ul>
          </section>
        </div>
    </div>
    <div class="champion-container">
        <button class="history__head center " @click="toggle('70')"><span class="history__head--circle">1971-1980</span></button>
        <div class="champions">  
            <section class="champions__sec">
                <h2 class="year-title">1971年<span class="year-title__sub">昭和46年</span></h2>
                <ul>
                    <li>平井裕／ノービス90cc</li>
                    <li>上田公次／ノービス125cc</li>
                    <li>大橋富夫／ノービス250cc</li>
                    <li>松谷光明／ノービス251cc以上</li>
                    <li>渡辺富士夫／ジュニア90cc</li>
                    <li>青木辰己／ジュニア125cc</li>
                    <li>内田隆／ジュニア250cc</li>
                    <li>加藤昇平／ジュニア251cc以上</li>
                    <li>江崎正／エキスパート・ジュニア90cc</li>
                    <li>遠藤恒雄／エキスパート・ジュニア125cc</li>
                    <li>中尾康夫／エキスパート・ジュニア250cc</li>
                    <li>浅見貞男／エキスパート・ジュニア251cc以上</li>
                    <li>金谷秀夫／セニア90cc</li>
                    <li>杉本泉／セニア125cc</li>
                    <li>大脇俊夫／セニア250cc</li>
                    <li>金谷秀夫／セニア251cc以上</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1972年<span class="year-title__sub">昭和47年</span></h2>
                <ul>
                     <li>菅原伸夫／ノービス90cc </li>
                     <li>坂 公平／ノービス125cc </li>
                     <li>上野真一／ノービス250cc </li>
                     <li>富江昭孝／ノービス251cc以上 </li>
                     <li>毛利良一／ジュニア90cc </li>
                     <li>大本十生／ジュニア125cc </li>
                     <li>大本十生／ジュニア250cc </li>
                     <li>片山敬済／ジュニア251cc以上 </li>
                     <li>渡辺富士夫／エキスパート・ジュニア125cc </li>
                     <li>阿部孝夫／エキスパート・ジュニア250cc </li>
                     <li>内田 隆／エキスパート・ジュニア251cc以上 </li>
                     <li>小田 豊／セニア125cc </li>
                     <li>小田 豊／セニア251cc以上 </li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1973年<span class="year-title__sub">昭和48年</span></h2>
                <ul>
                    <li>杉野順三／ノービス90cc</li>
                    <li>松山 守／ノービス125cc</li>
                    <li>橋本久仁啓／ノービス250cc</li>
                    <li>新田 茂／ジュニア90cc</li>
                    <li>坂 公平／ジュニア125cc</li>
                    <li>山崎達衛／ジュニア250cc</li>
                    <li>佐藤順造／ジュニア251cc以上</li>
                    <li>毛利良一／エキスパート・ジュニア125cc</li>
                    <li>片山敬済／エキスパート・ジュニア750cc</li>
                    <li>角谷新二／セニア125cc</li>
                    <li>根本 健／セニア750cc</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1974年<span class="year-title__sub">昭和49年</span></h2>
                <ul>
                    <li>岡崎隆史／ノービス90cc</li>
                    <li>佐藤健正／ノービス125cc</li>
                    <li>酒井 克／ノービス250cc</li>
                    <li>合津悟志／ジュニア90cc</li>
                    <li>石井康夫／ジュニア125cc</li>
                    <li>橋本久仁啓／ジュニア250cc</li>
                    <li>鈴木 修／ジュニア350cc</li>
                    <li>岩道 博／エキスパート・ジュニア125cc</li>
                    <li>阪本裕介／エキスパート・ジュニア750cc</li>
                    <li>青木辰己／セニア125cc</li>
                    <li>高井幾次郎／セニア750cc</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1975年<span class="year-title__sub">昭和50年</span></h2>
                <ul>
                    <li>片橋英治／アマチュア90cc</li>
                    <li>東金育男／アマチュア125cc</li>
                    <li>桶谷俊彦／アマチュア250cc</li>
                    <li>山梨 保／ジュニア125cc</li>
                    <li>酒井 克／ジュニア250cc</li>
                    <li>大島孝治／ジュニア350cc</li>
                    <li>相沢 清／エキスパート・ジュニア125cc</li>
                    <li>石井康男／エキスパート・ジュニア750cc</li>
                    <li>江崎 正／セニア125cc</li>
                    <li>浅見貞男／セニア750cc</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1976年<span class="year-title__sub">昭和51年</span></h2>
                <ul>
                    <li>牧野 栄／アマチュア90cc</li>
                    <li>川上 浩／アマチュア125cc</li>
                    <li>木下恵司／アマチュア250cc</li>
                    <li>東金育男／ジュニア125cc</li>
                    <li>水谷 勝／ジュニア250cc</li>
                    <li>太田一博／ジュニア350cc</li>
                    <li>飯田浩之／エキスパート125cc</li>
                    <li>毛利良一／エキスパート250cc</li>
                    <li>佐藤順造／エキスパート350cc</li>
                    <li>高井幾次郎／エキスパート750cc</li>
                    <li>牧野 栄／ノービス90cc</li>
                    <li>川上 浩／ノービス125cc</li>
                    <li>木下恵司／ノービス250cc</li>
                    <li>東金育男／ジュニア125cc</li>
                    <li>水谷 勝／ジュニア250cc</li>
                    <li>太田一博／ジュニア350cc</li>
                    <li>飯田浩之／エキスパート125cc</li>
                    <li>毛利良一／エキスパート250cc</li>
                    <li>佐藤順造／エキスパート350cc</li>
                    <li>高井幾次郎／エキスパート750cc</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1977年<span class="year-title__sub">昭和52年</span></h2>
                <ul>
                    <li>鈴木利彦／ノービス90cc</li>
                    <li>伊藤裕之／ノービス125cc</li>
                    <li>藤本泰東／ノービス250cc</li>
                    <li>川上 浩／ジュニア125cc</li>
                    <li>山名 久／ジュニア250cc</li>
                    <li>徳舛仁久／ジュニア350cc</li>
                    <li>飯田浩之／エキスパート125cc</li>
                    <li>鈴木 修／エキスパート350cc</li>
                    <li>毛利良一／エキスパート750cc</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1978年<span class="year-title__sub">昭和53年</span></h2>
                <ul>
                    <li>平野芳男／ノービス90cc</li>
                    <li>上田幸也／ノービス125cc</li>
                    <li>長谷川嘉久／ノービス250cc</li>
                    <li>伊藤裕之／ジュニア125cc</li>
                    <li>伊藤 巧／ジュニア250cc</li>
                    <li>藤本泰東／ジュニア350cc</li>
                    <li>上田公次／エキスパート125cc</li>
                    <li>上田公次／エキスパート250cc</li>
                    <li>石川岩夫／エキスパート350cc</li>
                    <li>上野真一／エキスパート750cc</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1979年<span class="year-title__sub">昭和54年</span></h2>
                <ul>
                    <li>富田英志／ノービス125cc</li>
                    <li>斉藤光雄／ノービス250cc</li>
                    <li>吉村俊宏／ジュニア125cc</li>
                    <li>阿部三吉／ジュニア250cc</li>
                    <li>平 忠彦／ジュニア350cc</li>
                    <li>斉藤三夫／国際A級125cc</li>
                    <li>木下恵司／国際A級350cc</li>
                    <li>水谷 勝／国際A級750cc</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1980年<span class="year-title__sub">昭和55年</span></h2>
                <ul>
                    <li>五百部徳雄／ノービス125cc</li>
                    <li>窪田正二／ノービス250cc</li>
                    <li>吉村俊宏／ジュニア125cc</li>
                    <li>垣内清孝／ジュニア250cc</li>
                    <li>田中光男／ジュニア350cc</li>
                    <li>一ノ瀬憲明／国際A級125cc</li>
                    <li>平 忠彦／国際A級350cc</li>
                    <li>鈴木 修／国際A級750cc</li>
                </ul>
            </section>
        </div>
    </div>
    <div class="champion-container">
        <button class="history__head center " @click="toggle('80')"><span class="history__head--circle">1981-1990</span></button>
        <div class="champions">  
            <section class="champions__sec">
                <h2 class="year-title">1981年<span class="year-title__sub">昭和56年</span></h2>
                <ul>
                    <li>荒木利春／ノービス125cc</li>
                    <li>中山博文／ノービス250cc</li>
                    <li>竹村浩生／国際B級125cc</li>
                    <li>七尾道夫／国際B級250cc</li>
                    <li>新井亮一／国際B級350cc</li>
                    <li>一ノ瀬憲明／国際A級125cc</li>
                    <li>藤本泰東／国際A級350cc</li>
                    <li>木下恵司／国際A級500cc</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1982年<span class="year-title__sub">昭和57年</span></h2>
                <ul>
                    <li>篠田雅樹／ノービス125cc</li>
                    <li>三浦 昇／ノービス250cc</li>
                    <li>荒木利春／国際B級125cc</li>
                    <li>小林 大／国際B級250cc</li>
                    <li>一ノ瀬憲明／国際A級125cc</li>
                    <li>福田照男／国際A級250cc</li>
                    <li>水谷 勝／国際A級500cc</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1983年<span class="year-title__sub">昭和58年</span></h2>
                <ul>
                    <li>吉田健一／ノービス125cc</li>
                    <li>宮城光／ノービス250cc</li>
                    <li>宮城光／ノービスTTF-3</li>
                    <li>篠田雅樹／国際B級125cc</li>
                    <li>坂口彰／国際B級250cc</li>
                    <li>栗谷二郎／国際A級125cc</li>
                    <li>斉藤光雄／国際A級250cc</li>
                    <li>平忠彦／国際A級500cc</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1984年<span class="year-title__sub">昭和59年</span></h2>
                <ul>
                    <li>山田浩史／ノービス125cc</li>
                    <li>塩森俊修／ノービス250cc</li>
                    <li>斉藤兼一／ノービスTTF-3</li>
                    <li>清水雅広／国際B級125cc</li>
                    <li>田村圭二／国際B級250cc</li>
                    <li>宮城光／国際B級TTF-3</li>
                    <li>宮城光／国際B級TTF-1</li>
                    <li>栗谷二郎／国際A級125cc</li>
                    <li>小林大／国際A級250cc</li>
                    <li>平忠彦／国際A級500cc</li>
                    <li>江崎正／国際A級TTF-3</li>
                    <li>八代俊二／国際A級TTF-1</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1985年<span class="year-title__sub">昭和60年</span></h2>
                <ul>
                    <li>井上賀博／国際B級125cc</li>
                    <li>塩森俊修／国際B級250cc</li>
                    <li>太田浩一／国際B級TTF-3</li>
                    <li>袴田利明／国際B級TTF-1</li>
                    <li>畝本 久／国際A級125cc</li>
                    <li>小林 大／国際A級250cc</li>
                    <li>平 忠彦／国際A級500cc</li>
                    <li>山本陽一／国際A級TTF-3</li>
                    <li>辻本 聡／国際A級TTF-1</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1986年<span class="year-title__sub">昭和61年</span></h2>
                <ul>
                    <li>藤沢哲也／ジュニア125cc</li>
                    <li>町井邦生／ジュニア250cc</li>
                    <li>町井邦生／ジュニアTTF-3</li>
                    <li>吉田健一／国際A級125cc</li>
                    <li>片山信二／国際A級250cc</li>
                    <li>木下恵司／国際A級500cc</li>
                    <li>山本陽一／国際A級TTF-3</li>
                    <li>辻本 聡／国際A級TTF-1</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1987年<span class="year-title__sub">昭和62年</span></h2>
                <ul>
                    <li>佐藤聡一郎／ジュニア125cc</li>
                    <li>嶋村健太／ジュニア250cc</li>
                    <li>新垣敏之／ジュニアTTF-3</li>
                    <li>畝本 久／国際A級125cc</li>
                    <li>清水雅広／国際A級250cc</li>
                    <li>藤原儀彦／国際A級500cc</li>
                    <li>田口益充／国際A級TTF-3</li>
                    <li>大島行弥／国際A級TTF-1</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1988年<span class="year-title__sub">昭和63年</span></h2>
                <ul>
                    <li>原田哲也／ジュニア125cc</li>
                    <li>永井康友／ジュニア250cc</li>
                    <li>白井直樹／ジュニアTTF-3</li>
                    <li>廣瀬政幸／国際A級125cc</li>
                    <li>本間利彦／国際A級250cc</li>
                    <li>藤原儀彦／国際A級500cc</li>
                    <li>塩森俊修／国際A級TTF-3</li>
                    <li>宮崎祥司／国際A級TTF-1</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1989年<span class="year-title__sub">昭和64年/平成元年</span></h2>
                <ul>
                    <li>坂田和人／ジュニア125cc</li>
                    <li>新井秀也／ジュニア250cc</li>
                    <li>福島 聡／ジュニアTTF-3</li>
                    <li>山崎冬樹／国際A級125cc</li>
                    <li>岡田忠之／国際A級250cc</li>
                    <li>藤原儀彦／国際A級500cc</li>
                    <li>ダグ・ポーレン／国際A級TTF-3</li>
                    <li>ダグ・ポーレン／国際A級TTF-1</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1990年<span class="year-title__sub">平成2年</span></h2>
                <ul>
                    <li>森兼昌明／国内A級125cc</li>
                    <li>茨木 繁／国内A級250cc</li>
                    <li>高橋勝義／国内A級TTF-3</li>
                    <li>渡辺 学／国内A級TTF-3（2st）</li>
                    <li>仲内正人／国内A級TTF-3（2st）</li>
                    <li>吉川和多留／国内A級SP750</li>
                    <li>坂田和人／国際A級125cc</li>
                    <li>岡田忠之／国際A級250cc</li>
                    <li>伊藤真一／国際A級500cc</li>
                    <li>鶴田竜二／国際A級TTF-3</li>
                    <li>森北貴行／国際A級TTF-3（2st）</li>
                    <li>小林 敏也／国際A級TTF-3（2st）</li>
                    <li>岩橋健一郎／国際A級TTF-1</li>
                </ul>
            </section>
        </div>
    </div>
    <div class="champion-container">
        <button class="history__head center " @click="toggle('90')"><span class="history__head--circle">1991-2000</span></button>
        <div class="champions">  
            <section class="champions__sec">
                <h2 class="year-title">1991年<span class="year-title__sub">平成3年</span></h2>
                <ul>
                    <li>稲垣幸則／国内A級125cc</li>
                    <li>宇川 徹／国内A級250cc</li>
                    <li>松戸直樹／国内A級TTF-3</li>
                    <li>阿部徹郎／国内A級SP750</li>
                    <li>椎名 明／スーパーカップTTF-3（2st）</li>
                    <li>小野真央／国際A級125cc</li>
                    <li>岡田忠之／国際A級250cc</li>
                    <li>ピーター・ゴダート／国際A級500cc</li>
                    <li>高橋勝義／国際A級TTF-3</li>
                    <li>宮崎祥司／国際A級TTF-1</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1992年<span class="year-title__sub">平成4年</span></h2>
                <ul>
                    <li>斉藤 明／国際A級125cc</li>
                    <li>原田哲也／国際A級250cc</li>
                    <li>ダリル・ビーティー／国際A級500cc</li>
                    <li>塚本昭一／国際A級TTF-1</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1993年<span class="year-title__sub">平成5年</span></h2>
                <ul>
                    <li>加藤義昌／国際A級125cc</li>
                    <li>宇川 徹／国際A級250cc</li>
                    <li>阿部典史／国際A級500cc</li>
                    <li>北川圭一／国際A級TTF-1</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1994年<span class="year-title__sub">平成6年</span></h2>
                <ul>
                    <li>宮坂 賢／国際A級125cc</li>
                    <li>宇川 徹／国際A級250cc</li>
                    <li>吉川和多留／国際A級スーパーバイク</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1995年<span class="year-title__sub">平成7年</span></h2>
                <ul>
                    <li>宇井陽一／国際125cc</li>
                    <li>沼田憲保／国際250cc</li>
                    <li>青木拓磨／国際スーパーバイク</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1996年<span class="year-title__sub">平成8年</span></h2>
                <ul>
                    <li>東 雅雄／国際125cc</li>
                    <li>沼田憲保／国際250cc</li>
                    <li>青木拓磨／国際スーパーバイク</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1997年<span class="year-title__sub">平成9年</span></h2>
                <ul>
                    <li>秋田貴志／国際125cc</li>
                    <li>加藤大治郎／国際250cc</li>
                    <li>芳賀紀行／国際スーパーバイク</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1998年<span class="year-title__sub">平成10年</span></h2>
                <ul>
                    <li>仲城英幸／国際125cc</li>
                    <li>中野真矢／国際250cc</li>
                    <li>伊藤真一／国際スーパーバイク</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">1999年<span class="year-title__sub">平成11年</span></h2>
                <ul>
                    <li>仲城英幸／国際125cc</li>
                    <li>松戸直樹／国際250cc</li>
                    <li>吉川和多留／国際スーパーバイク</li>
                    <li>蒲田 学／国際S-NK</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2000年<span class="year-title__sub">平成12年</span></h2>
                <ul>
                    <li>小山知良／国際125cc</li>
                    <li>中冨伸一／国際250cc</li>
                    <li>井筒仁康／国際スーパーバイク</li>
                    <li>鶴田竜二／国際S-NK</li>
                </ul>
            </section>
        </div>
    </div>
    <div class="champion-container">
        <button class="history__head center " @click="toggle('100')"><span class="history__head--circle">2001-2010</span></button>
        <div class="champions">  
            <section class="champions__sec">
                <h2 class="year-title">2001年<span class="year-title__sub">平成13年</span></h2>
                <ul>
                    <li>仲城英幸／国際125cc</li>
                    <li>関口太郎／国際250cc</li>
                    <li>武田雄一／国際ST600</li>
                    <li>梁 明／国際スーパーバイク</li>
                    <li>北川圭一／国際S-NK</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2002年<span class="year-title__sub">平成14年</span></h2>
                <ul>
                    <li>仲城英幸／国際125cc</li>
                    <li>嘉陽哲久／国際250cc</li>
                    <li>清成龍一／国際ST600</li>
                    <li>渡辺 篤／国際スーパーバイク</li>
                    <li>山口辰也／国際JSB1000</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2003年<span class="year-title__sub">平成15年</span></h2>
                <ul>
                    <li>青山周平／国際125cc</li>
                    <li>青山博一／国際250cc</li>
                    <li>小西良輝／国際ST600</li>
                    <li>北川圭一／国際JSB1000</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2004年<span class="year-title__sub">平成16年</span></h2>
                <ul>
                    <li>仲城英幸／国際125cc</li>
                    <li>高橋裕紀／国際250cc</li>
                    <li>辻村 猛／国際ST600</li>
                    <li>井筒仁康／国際JSB1000</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2005年<span class="year-title__sub">平成17年</span></h2>
                <ul>
                    <li>菊池寛幸／国際125cc</li>
                    <li>青山周平／国際250cc</li>
                    <li>安田毅史／国際ST600</li>
                    <li>伊藤真一／国際JSB1000</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2006年<span class="year-title__sub">平成18年</span></h2>
                <ul>
                    <li>森 隆嘉／国内GP-MONO</li>
                    <li>山下 佑／国際GP-MONO</li>
                    <li>中上貴晶／国際125cc</li>
                    <li>横江竜司／国際250cc</li>
                    <li>安田毅史／国際ST600</li>
                    <li>伊藤真一／国際JSB1000</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2007年<span class="year-title__sub">平成19年</span></h2>
                <ul>
                    <li>阿部徹郎／国内GP-MONO</li>
                    <li>森 隆嘉／国際GP-MONO</li>
                    <li>岩田裕臣／国際125cc</li>
                    <li>富沢祥也／国際125ユース</li>
                    <li>宇井陽一／国際250cc</li>
                    <li>小西良輝／国際ST600</li>
                    <li>渡辺 篤／国際JSB1000</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2008年<span class="year-title__sub">平成20年</span></h2>
                <ul>
                    <li>長島哲太／国内GP-MONO</li>
                    <li>乃村康友／国際GP-MONO</li>
                    <li>菊池寛幸／国際125cc</li>
                    <li>尾野弘樹／国際125ユース</li>
                    <li>高橋 巧／国際250cc</li>
                    <li>小西良輝／国際ST600</li>
                    <li>中須賀克行／国際JSB1000</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2009年<span class="year-title__sub">平成21年</span></h2>
                <ul>
                    <li>花房一樹／国際GP-MONO</li>
                    <li>菊池寛幸／国際125cc</li>
                    <li>尾野弘樹／国際125ユース</li>
                    <li>宇井陽一／国際250cc</li>
                    <li>手島雄介／国際ST600</li>
                    <li>中須賀克行／国際JSB1000</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2010年<span class="year-title__sub">平成22年</span></h2>
                <ul>
                    <li>藤井謙汰／国際GP-MONO</li>
                    <li>大久保光／国際J-GP3・J-GP3ユースカップ</li>
                    <li>小西良輝／国際J-GP2</li>
                    <li>山口辰也／国際ST600</li>
                    <li>秋吉耕佑／国際JSB1000</li>
                </ul>
            </section>
        </div>
    </div>
    <div class="champion-container">
        <button class="history__head center " @click="toggle('110')"><span class="history__head--circle">2011-2020</span></button>
        <div class="champions">  
            <section class="champions__sec">
                <h2 class="year-title">2011年<span class="year-title__sub">平成23年</span></h2>
                <ul>
                    <li>藤井謙汰／国際J-GP3・J-GP3ユースカップ</li>
                    <li>中上貴晶／国際J-GP2</li>
                    <li>秋吉耕佑／国際JSB1000</li>
                    <li>山口辰也／国際ST600</li>
                    <li>長島哲太／国際GP-MONO</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2012年<span class="year-title__sub">平成24年</span></h2>
                <ul>
                    <li>徳留真紀／国際J-GP3</li>
                    <li>山田誓己／J-GP3ユースカップ</li>
                    <li>渡辺一樹／国際J-GP2</li>
                    <li>中須賀克行／国際JSB1000</li>
                    <li>デチャ・クライサー／国際ST600</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2013年<span class="year-title__sub">平成25年</span></h2>
                <ul>
                    <li>山田誓己／国際J-GP3</li>
                    <li>國峰啄磨／J-GP3ユースカップ</li>
                    <li>野左根航汰／国際J-GP2</li>
                    <li>中須賀克行／国際JSB1000</li>
                    <li>渡辺一馬／国際ST600</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2014年<span class="year-title__sub">平成26年</span></h2>
                <ul>
                    <li>山田誓己／国際J-GP3</li>
                    <li>水野 涼／J-GP3ユースカップ</li>
                    <li>高橋裕紀／国際J-GP2</li>
                    <li>中須賀克行／国際JSB1000</li>
                    <li>小林龍太／国際ST600</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2015年<span class="year-title__sub">平成27年</span></h2>
                <ul>
                    <li>水野 涼／国際J-GP3・J-GP3ユースカップ</li>
                    <li>高橋裕紀／国際J-GP2</li>
                    <li>中須賀克行／国際JSB1000</li>
                    <li>横江竜司／国際ST600</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2016年<span class="year-title__sub">平成28年</span></h2>
                <ul>
                    <li>徳留真紀／国際J-GP3</li>
                    <li>伊達悠太／J-GP3ユースカップ</li>
                    <li>浦本修充／国際J-GP2</li>
                    <li>中須賀克行／国際JSB1000</li>
                    <li>榎戸育寛／国際ST600</li>
                    <li>笠井悠太／国際MFJカップJP250</li>
                    <li>田中 歩／国内MFJカップJP250</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2017年<span class="year-title__sub">平成29年</span></h2>
                <ul>
                    <li>伊達悠太／国際J-GP3・J-GP3ユースカップ</li>
                    <li>水野 涼／国際J-GP2</li>
                    <li>高橋 巧／国際JSB1000</li>
                    <li>前田恵助／国際ST600</li>
                    <li>藤井謙汰／国際MFJカップJP250</li>
                    <li>上原大輝／国内MFJカップJP250</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2018年<span class="year-title__sub">平成30年</span></h2>
                <ul>
                    <li>中島元気／国際J-GP3</li>
                    <li>岩戸亮介／国際J-GP2</li>
                    <li>中須賀克行／国際JSB1000</li>
                    <li>岡本裕生／国際ST600</li>
                    <li>笠井悠太／国際MFJカップJP250</li>
                    <li>家根谷大晟／国内MFJカップJP250</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2019年<span class="year-title__sub">平成31年/令和元年</span></h2>
                <ul>
                    <li>長谷川聖／国際J-GP3</li>
                    <li>名越哲平／国際J-GP2</li>
                    <li>中須賀克行／国際JSB1000</li>
                    <li>小山知良／国際ST600</li>
                    <li>笠井悠太／国際MFJカップJP250</li>
                    <li>松岡 玲／国内MFJカップJP250</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2020年<span class="year-title__sub">令和2年</span></h2>
                <ul>
                    <li>村瀬健琉／国際J-GP3</li>
                    <li>高橋裕紀／国際ST1000</li>
                    <li>野左根航汰／国際JSB1000</li>
                    <li>岡本裕生／国際ST600</li>
                    <li>笠井悠太／国際MFJカップJP250</li>
                    <li>田中敬秀／国内MFJカップJP250</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2021年<span class="year-title__sub">令和3年</span></h2>
                <ul>
                    <li>中須賀 克行／国際JSB1000</li>
                    <li>渡辺 一馬／国際ST1000</li>
                    <li>埜口 遥希／国際ST600</li>
                    <li>尾野 弘樹／国際J-GP3</li>
                    <li>篠崎 佐助／国際MFJカップJP250</li>
                    <li>梶山 采千夏／国内MFJカップJP250</li>
                </ul>
            </section>
            <section class="champions__sec">
                <h2 class="year-title">2022年<span class="year-title__sub">令和4年</span></h2>
                <ul>
                    <li>中須賀 克行／国際JSB1000</li>
                    <li>渡辺 一馬／国際ST1000</li>
                    <li>荒川 晃大／国際ST600</li>
                    <li>尾野 弘樹／国際J-GP3</li>
                    <li>中村 龍之介／国際MFJカップJP250</li>
                    <li>山根 昇馬／国内MFJカップJP250</li>
                </ul>
            </section>
        </div>
    </div>
</div>
</template>

<script>
    import Mixin from '@/mixins/mixin.js'
    export default {
        data: function() {
            return {
                show_contents: ['60']
            }
        },
        mixins: [Mixin],
    }
</script>

<style lang="scss">

</style>